import { createTheme } from "react-data-table-component"

export const RA_DARK_THEME = "ra-dark"

createTheme(
  RA_DARK_THEME,
  {
    text: {
      primary: "rgba(248, 250, 252, 0.92)",
      secondary: "rgba(248, 250, 252, 0.65)",
      disabled: "rgba(248, 250, 252, 0.35)",
    },
    background: {
      default: "transparent",
    },
    context: {
      background: "rgba(124, 58, 237, 0.16)",
      text: "#F8FAFC",
    },
    divider: {
      default: "rgba(255, 255, 255, 0.08)",
    },
    action: {
      button: "#A78BFA",
      hover: "rgba(124, 58, 237, 0.16)",
      disabled: "rgba(248, 250, 252, 0.25)",
    },
    striped: {
      default: "rgba(255, 255, 255, 0.02)",
      text: "rgba(248, 250, 252, 0.92)",
    },
    highlightOnHover: {
      default: "rgba(124, 58, 237, 0.10)",
      text: "#F8FAFC",
    },
    selected: {
      default: "rgba(124, 58, 237, 0.18)",
      text: "#F8FAFC",
    },
    sortFocus: {
      default: "#A78BFA",
    },
  },
  "dark"
)

export const dataTableCustomStyles = {
  table: {
    style: {
      backgroundColor: "transparent",
      color: "#F8FAFC",
    },
  },
  headRow: {
    style: {
      backgroundColor: "rgba(255, 255, 255, 0.03)",
      borderBottomColor: "rgba(255, 255, 255, 0.08)",
      color: "rgba(248, 250, 252, 0.65)",
      fontSize: "11px",
      fontWeight: 600,
      letterSpacing: "0.04em",
      textTransform: "uppercase" as const,
      minHeight: "44px",
    },
  },
  headCells: {
    style: {
      color: "rgba(248, 250, 252, 0.65)",
    },
  },
  rows: {
    style: {
      backgroundColor: "transparent",
      color: "rgba(248, 250, 252, 0.92)",
      minHeight: "44px",
      borderBottomColor: "rgba(255, 255, 255, 0.06)",
      "&:not(:last-of-type)": {
        borderBottomColor: "rgba(255, 255, 255, 0.06)",
      },
    },
    stripedStyle: {
      backgroundColor: "rgba(255, 255, 255, 0.02)",
    },
    highlightOnHoverStyle: {
      backgroundColor: "rgba(124, 58, 237, 0.10)",
      color: "#F8FAFC",
      transitionDuration: "0.15s",
      transitionProperty: "background-color",
      borderBottomColor: "rgba(255, 255, 255, 0.06)",
      outline: "none",
    },
  },
  cells: {
    style: {
      color: "rgba(248, 250, 252, 0.92)",
    },
  },
  pagination: {
    style: {
      backgroundColor: "transparent",
      color: "rgba(248, 250, 252, 0.7)",
      borderTopColor: "rgba(255, 255, 255, 0.08)",
    },
    pageButtonsStyle: {
      color: "rgba(248, 250, 252, 0.7)",
      fill: "rgba(248, 250, 252, 0.7)",
      "&:hover:not(:disabled)": {
        backgroundColor: "rgba(124, 58, 237, 0.16)",
        color: "#F8FAFC",
      },
      "&:disabled": {
        color: "rgba(248, 250, 252, 0.25)",
        fill: "rgba(248, 250, 252, 0.25)",
      },
    },
  },
  noData: {
    style: {
      backgroundColor: "transparent",
      color: "rgba(248, 250, 252, 0.5)",
      padding: "32px",
    },
  },
  progress: {
    style: {
      backgroundColor: "transparent",
      color: "#A78BFA",
    },
  },
}
